import React from 'react';
import { Grid, TextField, Box, Typography } from '@mui/material';

const ContactInfoStep = ({ formData, onChange, errors }) => {
  const handleChange = (field) => (event) => {
    onChange({ ...formData, [field]: event.target.value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Contact Information
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        Enter the director's contact details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            type="email"
            label="Email Address"
            value={formData.email}
            onChange={handleChange('email')}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            label="Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange('mobileNumber')}
            placeholder="+971-XX-XXX-XXXX"
            error={!!errors.mobileNumber}
            helperText={errors.mobileNumber || 'Format: +971-XX-XXX-XXXX'}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Address"
            value={formData.address}
            onChange={handleChange('address')}
            helperText="Optional"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactInfoStep;
